import { CurrencyModel } from '../../../../../../../models/Settings/Financial/CurrencyModel';
import { ReservationCardGroupModel } from '../../../../../../ReservationModule/pages/CreateReservationPageNew/models';
import { exportFileTypes } from '../../../../../models/exportFileTypes';

export interface AgencyPerfermanceOverviewReportFormModel {
  from: string | null;
  to: string | null;
  room_type_ids: number[];
  market_code_ids: number[];
  segment_market_code_ids: number[];
  cards: ReservationCardGroupModel[];
  gross_revenue: boolean;
  with_revenue: boolean;
  currency: CurrencyModel | null;
  currency_application: CurrencyApplicationEnum | null;
  fixed_at: string | null;
  file_type: exportFileTypes;

  grouped_by: GroupedByEnum;
}

export enum GroupedByEnum {
  NONE = 'none',
  MARKET_CODE = 'market_code',
  MARKET_SEGMENT = 'market_segment',
}

export enum CurrencyApplicationEnum {
  FIXED = 'fixed',
  DAILY = 'daily',
}
